import {useCallback,useRef} from 'react';

/** Per-mounted-operation synchronous guard, independent of React render timing.
 * Acquire before starting a mutation; always release in finally (including
 * cancellation). This does not deduplicate distinct actions or replace server
 * RBAC, version checks, transactions, or stable request idempotency keys.
 */
export function useMutationLock(){
 const pending=useRef(false);
 const acquire=useCallback(()=>{if(pending.current)return false;pending.current=true;return true},[]);
 const release=useCallback(()=>{pending.current=false},[]);
 return {acquire,release,pending};
}
